import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=16d27b9f&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=ts&"
export * from "./LeftBar.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=16d27b9f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d27b9f",
  null
  
)

export default component.exports